import { useState } from "react";

import '../../styles/Animator.css';

import { FaFacebook,
    FaInstagram,
    FaWhatsapp,
    FaBullseye,
    FaStar 
  } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { AiFillHome, AiFillMessage } from "react-icons/ai";
import { GiStairs, GiHamburgerMenu } from "react-icons/gi";
import { FaGears } from "react-icons/fa6";

export function AppIcon({ iconName }) {

  const [isHovered, setIsHovered] = useState(false);

	let iconRender;

	switch(iconName){
		case "Facebook":
			iconRender = <FaFacebook />;
			break;
		case "Instragram":
			iconRender = <FaInstagram />;
			break;
		case "Whatsapp":
			iconRender = <FaWhatsapp />;
			break;
		case "Mail":
			iconRender = <MdEmail />;
			break;
		case "Inicio":
			iconRender = <AiFillHome />;
			break;
		case "Experiencias":
			iconRender = <GiStairs />;
			break;
		case "Propósito":
			iconRender = <FaBullseye />;
			break;
		case "Producimos":
			iconRender = <FaGears />;
			break;
		case "Servicios":
			iconRender = <FaStar />;
			break;
		case "Contáctanos":
			iconRender = <AiFillMessage />;
			break;
    case "Hamburger":
      iconRender = <GiHamburgerMenu />;
      break;
	}

	return(
		<div 
      className={`${isHovered ? 'pulse' : ''} `}
      onMouseEnter={()=>{setIsHovered(true)}}
      onMouseLeave={()=>{setIsHovered(false)}}
    >
      {iconRender}
		</div>
	)
};